// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const isRunningOnCypress = Boolean((window as any).Cypress)
export const isRunningOnPlaywright = localStorage.getItem('isPlaywright') === 'true'
export const isRunningReleaseTest = localStorage.getItem('isReleaseTest') === 'true'
export const isAutomatedBrowser = isRunningOnPlaywright || isRunningReleaseTest
